import { Server } from 'miragejs';

import factories from './factories';
import fixtures from './fixtures';
import models from './models';
import routes from './routes';
import serializers from './serializers';
import seeds from './seeds';

const hasKeys = (obj) => !!Object.keys(obj).length;

const getConfig = (environment = 'test') => ({
  environment,
  factories,
  models,
  serializers,
  routes,
  seeds,
  ...(hasKeys(fixtures) ? { fixtures } : null),
});

export function makeServer({ environment } = {}) {
  const config = getConfig(environment);
  const server = new Server(config);

  return server;
}
